import * as React from 'react';
import { ITableConfig } from '../../common/table';
import PagedResultSet from '../../../models/common/PagedResultSet';
import User from '../../../models/User';
// import { Button } from '@blueprintjs/core';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
// import Card from 'src/components/common/Card.redesign';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Card from 'src/components/common/Card.redesign';
import Filter from 'src/components/common/Filter';
import { ODataOptions } from 'src/util/ODataBuilder';
import Dialog, { DialogActionBar } from 'src/components/common/Dialog.redesign';
import UserRole from 'src/models/UserRole';
import ErrorResponse from 'src/models/ErrorResponse';

import './AdminUsersPage.scss';

export const getUserRoleDisplay = (user: User): string => {
    const roles: UserRole[] = user.roles && user.roles.length > 0 ? user.roles : user.role ? [user.role] : [];
    return roles.map((role) => role.role).join(', ');
};

interface IAdminUserPageStateProps {
    isLoading: boolean;
    users: PagedResultSet<User> | undefined;
    tableConfig: ITableConfig;
}

interface IAdminUserStatusProps {
    isDialogOpen: boolean;
    dialogText: string;
    userId: number;
    selectedUser: User;
    isSafeguardDialogOpen: boolean;
    safeguardMessage: string;
    isChangingStatus: boolean;
}

export interface IAdminUserPageDispatchProps {
    getUsers: (options: ODataOptions, resetPage?: boolean) => void;
    incrementUsers: () => void;
    initUsers: () => void;
    navigate: (path: string) => void;
    toggleUserStatus: (id: number, onComplete?: (error?: ErrorResponse) => void) => void;
}

type IAdminUserPageProps = IAdminUserPageStateProps & IAdminUserPageDispatchProps & IAdminUserStatusProps;

export class AdminUserPage extends React.Component<IAdminUserPageProps> {
    constructor(props: IAdminUserPageProps) {
        super(props);
    }

    state: IAdminUserStatusProps = {
        isDialogOpen: false,
        dialogText: 'Deactivate',
        userId: undefined,
        selectedUser: undefined,
        isSafeguardDialogOpen: false,
        safeguardMessage: '',
        isChangingStatus: false,
    };

    componentDidMount() {
        this.props.getUsers(new ODataOptions(), true);
    }

    componentWillUnmount() {
        this.props.initUsers();
    }

    editUser(userId: number) {
        console.log('Edit User', userId);
        this.props.navigate(`/admin/edit-user/${userId}`);
    }

    showConfirmation(user: User) {
        this.setState({
            isDialogOpen: true,
            userId: user.id,
            selectedUser: user,
            dialogText: user?.accountDisabled ? 'Reactivate' : 'Deactivate',
        });
    }

    changeUserStatus() {
        this.setState({ isChangingStatus: true });
        this.props.toggleUserStatus(this.state.userId, (error?: ErrorResponse) => {
            if (error) {
                this.setState({
                    isDialogOpen: false,
                    isSafeguardDialogOpen: true,
                    safeguardMessage: error.message || 'Unable to update account status.',
                    isChangingStatus: false,
                });
                return;
            }
            this.setState({ isDialogOpen: false, isChangingStatus: false });
            window.alert('Account status updated');
        });
    }

    closeDialog() {
        this.setState({ isDialogOpen: false });
    }

    displayUsers() {
        if (this.props.users?.items && this.props.users.items.length > 0) {
            return this.props.users.items.map((user: User, index: number) => {
                return (
                    <Card
                        key={index}
                        badge={`User ${user.username}`}
                        contextActions={[
                            { text: 'Edit User', action: () => this.editUser(user.id) },
                            { text: `${user.accountDisabled ? 'Activate' : 'Deactivate'} User`, action: () => this.showConfirmation(user) },
                        ]}
                        newContext={true}
                        showMenu={true}
                    >
                        <div className="admin-user-row">
                            <div>{`${user.firstName} ${user.lastName}`}</div>
                            <div>{user.type?.name}</div>
                            <div>{getUserRoleDisplay(user)}</div>
                            <div>{user.lmsNumber}</div>
                        </div>
                    </Card>
                );
            });
        } else {
            return <div>No Users available</div>;
        }
    }

    handleUserFilterChanged = (options: ODataOptions) => {
        console.log('at component', options);
        this.props.initUsers();
        this.props.getUsers(options, true);
    };

    public render() {
        const addUser = () => this.props.navigate('/admin/create-user');
        const { users } = this.props;
        let isOnLastPage = false;
        if (users) {
            isOnLastPage = users.pageNumber * users.pageSize < users.totalRecords;
        }

        return (
            <div className="admin-users-page">
                <header className="admin-users-header">
                    <div>
                        <h2>User Management</h2>
                        <p>Search, create, and maintain user accounts.</p>
                    </div>
                </header>
                <div className="admin-users-panel">
                    <div className="admin-users-filter">
                        <Filter
                            filterItems={[
                                { group: 1, text: 'First Name', orderName: 'firstName', orderDirection: 'descending' },
                                { group: 1, text: 'Last Name', orderName: 'lastName', orderDirection: 'descending' },
                                { group: 1, text: 'Username', orderName: 'username', orderDirection: 'descending' },
                                { group: 1, text: 'Office', orderName: 'office', orderDirection: 'descending' },
                                { group: 1, text: 'User Role', orderName: 'role', orderDirection: 'descending' },
                                { group: 1, text: 'LMS Number', orderName: 'lmsNumber', orderDirection: 'descending' },
                            ]}
                            onFilterChanged={this.handleUserFilterChanged}
                        />
                    </div>
                    <div className="admin-users-columns" aria-hidden={true}>
                        <div><b>Name</b></div>
                        <div><b>Type</b></div>
                        <div><b>Roles</b></div>
                        <div><b>LMS Number</b></div>
                    </div>
                    <CardContainer
                        showNextPagePanel={isOnLastPage}
                        nextPageAction={this.props.incrementUsers}
                        buttonPaging={true}
                        className="admin-users-list"
                    >
                        {this.displayUsers()}
                    </CardContainer>
                    <div className="admin-users-footer">
                        <Button onClick={addUser} text="Create User" />
                    </div>
                </div>
                {this.state.isDialogOpen && (
                    <Dialog title={'Confirm Action'}>
                        <div>{`Are you sure you want to ${this.state.dialogText.toLocaleLowerCase()} ${this.state.selectedUser?.firstName} ${
                            this.state.selectedUser?.lastName
                        }?`}</div>
                        <DialogActionBar>
                            <Button
                                intent="primary"
                                onClick={() => this.changeUserStatus()}
                                text={this.state.dialogText + ' User'}
                                disabled={this.state.isChangingStatus}
                                loading={this.state.isChangingStatus}
                            />
                            <Button intent="danger" onClick={() => this.setState({ isDialogOpen: false })} text="Cancel" />
                        </DialogActionBar>
                    </Dialog>
                )}
                {this.state.isSafeguardDialogOpen && (
                    <Dialog title="Administrator Required">
                        <div>{this.state.safeguardMessage}</div>
                        <DialogActionBar>
                            <Button
                                intent="primary"
                                text="Assign Another Administrator"
                                onClick={() => this.props.navigate('/admin/roles#user-role-assignments')}
                            />
                            <Button
                                text="Close"
                                onClick={() => this.setState({ isSafeguardDialogOpen: false })}
                            />
                        </DialogActionBar>
                    </Dialog>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IRootState) => ({
    isLoading: selectors.user.isLoadingUsers(state),
    users: selectors.user.users(state),
    tableConfig: selectors.user.adminUsersPageTableConfig(state),
});

const mapDispatchToProps: IAdminUserPageDispatchProps = {
    getUsers: (options: ODataOptions, resetPage?: boolean) => actions.user.getUsersForPage(options, resetPage),
    incrementUsers: () => actions.user.incrementUsers(),
    initUsers: () => actions.user.initUsers(),
    navigate: (path: string) => push(path),
    toggleUserStatus: (id: number, onComplete?: (error?: ErrorResponse) => void) => actions.user.toggleUserStatus(id, onComplete),
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserPage);



// WEBPACK FOOTER //
// ./src/components/admin/sections/AdminUsersPage.tsx